import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/auth/login")({
  beforeLoad: ({ context }) => {
    context.auth.signinRedirect();
  },
});
